import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatError } from "../../lib/api";
import { AdminTitle, AdminField, Panel } from "./AdminUi";

const DAYS = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];
const ST = { annule: "Annulé", a_confirmer: "À confirmer", confirme: "Confirmé" };
const sel = "mt-1.5 w-full bg-[#0B0B0B] border border-[#C9A45C]/25 px-3 py-2.5 text-sm";
const longDate = (d) => new Date(`${d}T12:00:00`).toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

export const MarketExceptions = ({ schedule }) => {
  const [items, setItems] = useState([]);
  const [f, setF] = useState({ schedule_id: "", date: "", status: "annule", note: "" });
  const load = () => api.get("/admin/market-exceptions").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const name = (id) => { const s = schedule.find((x) => x.id === id); return s ? `${s.city} (${DAYS[s.weekday].toLowerCase()})` : "Marché supprimé"; };
  const save = async (e) => {
    e.preventDefault();
    try { await api.put("/admin/market-exceptions", f); toast.success("Date mise à jour"); setF({ ...f, date: "", note: "" }); load(); }
    catch (err) { toast.error(formatError(err)); }
  };
  const del = async (x) => { await api.delete(`/admin/market-exceptions/${x.id}`); toast.success("Statut habituel rétabli"); load(); };

  return (
    <div data-testid="admin-market-exceptions">
      <AdminTitle title="Annulations et changements par date">Annulez ou modifiez le statut d'une seule date, sans toucher aux autres semaines.</AdminTitle>
      <Panel className="p-5">
        <form onSubmit={save} className="grid sm:grid-cols-4 gap-4 items-end" data-testid="exception-form">
          <label className="block sm:col-span-2"><span className="text-[10px] tracking-[0.2em] uppercase text-[#F8F6F1]/50">Marché</span>
            <select required value={f.schedule_id} onChange={set("schedule_id")} className={sel} data-testid="exception-form-market">
              <option value="">Choisir…</option>
              {schedule.map((s) => <option key={s.id} value={s.id}>{DAYS[s.weekday]} — {s.city}</option>)}
            </select></label>
          <AdminField label="Date" type="date" required value={f.date} onChange={set("date")} testid="exception-form-date" />
          <label className="block"><span className="text-[10px] tracking-[0.2em] uppercase text-[#F8F6F1]/50">Statut ce jour-là</span>
            <select value={f.status} onChange={set("status")} className={sel} data-testid="exception-form-status">
              {Object.entries(ST).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select></label>
          <AdminField className="sm:col-span-3" label="Message aux clients (facultatif, ex. météo)" value={f.note} onChange={set("note")} testid="exception-form-note" />
          <button type="submit" className="btn-gold !py-3" data-testid="exception-form-submit">Appliquer</button>
        </form>
      </Panel>
      <div className="mt-4 space-y-2">
        {items.map((x) => (
          <Panel key={x.id} className="p-4 flex items-center gap-4" data-testid={`admin-exception-${x.id}`}>
            <div className="flex-1 min-w-0">
              <p className="text-sm">{name(x.schedule_id)} — <span className="capitalize">{longDate(x.date)}</span></p>
              <p className={`text-xs ${x.status === "annule" ? "text-red-300" : "text-[#E5C178]"}`}>{ST[x.status]}{x.note && ` · ${x.note}`}</p>
            </div>
            <button onClick={() => del(x)} className="p-2 hover:text-red-400" aria-label="Rétablir" title="Rétablir le statut habituel" data-testid={`admin-delete-exception-${x.id}`}><Trash2 className="h-4 w-4" /></button>
          </Panel>
        ))}
        {!items.length && <p className="text-sm text-[#F8F6F1]/45">Aucun changement à venir.</p>}
      </div>
    </div>
  );
};
